export default {
  title: {
    en: 'Introducing car scent club by drift',
  },
}
